import { computed, unref, type MaybeRef } from 'vue'
import { createQuery } from '@/queries'
import { getSupportedBrands } from '@/features/sizes/api/sizes'

/** `GET /size-recommendation/brands` — every house the size recommender serves (names). */
export const useSizeRecommendationBrandsQuery = (enabled: MaybeRef<boolean> = true) => {
  return createQuery<string[]>({
    key: computed(() => (unref(enabled) ? ['size-recommendation', 'brands'] : null)),
    fetcher: async () => (await getSupportedBrands()).map((brand) => brand.value),
    staleTime: 60 * 60 * 1000,
  })
}
